import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";

const SimpleSearch = ({ placeholder = "Search", width = 300, onChange = () => { }, delay = 750 },) => {
  const [text, setText] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(text);
    }, delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, onChange]);

  return (
    <>
      <Input
        style={{ width }}
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </>
  );
};

export default SimpleSearch;